import React, { useRef, useState, useEffect, useMemo } from "react";
import Dailymotion from "react-dailymotion";
import { clickTrackLog } from "../services/clickTrack.service";

export const DailyMotionPlayer = (props) => {
  const [played, setPlayed] = useState(false);

  const { url, eventId, exhibitorId, clientKey, clickTrack = true } = props;

  const extractIdFromUrl = () => {
    let startString = "";

    try {
      if (url.includes("https://dai.ly/")) {
        startString = "https://dai.ly/";
        var tempString = url.replace(startString, "");

        return tempString.substring(
          0,
          tempString.includes("?") ? tempString.indexOf("?") : tempString.length
        );
      } else if (url.includes("https://www.dailymotion.com/video/")) {
        startString = "https://www.dailymotion.com/video/";
        var tempString = url.replace(startString, "");

        return tempString.substring(
          0,
          tempString.includes("?") ? tempString.indexOf("?") : tempString.length
        );
      }
    } catch (error) {
      if (!url) return "";
    }
  };

  const onPlay = () => {
    if (played) return;
    setPlayed(true);
    clickTrackLog(
      eventId,
      exhibitorId,
      clientKey,
      "DailyMotionVideo",
      url,
      "Exhibitor"
    );
  };

  const id = useMemo(() => {
    return extractIdFromUrl();
  }, [url]);

  return <Dailymotion video={id} onPlay={onPlay} uiTheme="light" />;
};
